/*es5-ext/object/keys/is-implemented*/
function _(require, module, exports) {
    module.exports = function () {
        try {
            Object.keys('primitive');
            return true;
        } catch (e) {
            return false;
        }
    };
}